/**
 * Labstep
 *
 * @module components/Notification/Card/EmptyState
 * @desc Empty state for notification
 */

import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';
import type { NotificationCardEmptyStateProps } from './types';

export const NotificationCardEmptyState: React.FC<
  NotificationCardEmptyStateProps
> = ({ img }) => (
  <CardEmptyState
    src={img ? '/img/empty-state/notifications.svg' : undefined}
    title="No news is good news"
    explanation="You have no notifications"
  />
);

NotificationCardEmptyState.defaultProps = {
  img: true,
};
